import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Context, CartSlider, Cart } from '@grandvisionhq/carts-v2';
import { toast } from '@grandvisionhq/common';
import { useLink } from '@grandvisionhq/frk-routing';
import { WithUserData } from '@grandvisionhq/my-account';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { pushCheckoutEventToDataLayer } from '../data-layer.js';
import '../context/CheckoutSettings/context.js';
import '@grandvisionhq/utils';
import '../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '../mappers/errors-mapping.js';
import '../utils/get-customer-details-payload.js';
import '../models/cart/cart-state.js';
import '../models/checkout/checkout-step-error-type.js';
import '../models/checkout-settings.js';
import '../models/step-shipping/shipping-methods.js';
import '../models/shared.js';
import 'history';
import '../utils/has-cart-errors.js';
import '@grandvisionhq/payments';
import '@grandvisionhq/auth';
import '../selectors.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../operations/mutations/set-customer-details.js';
import '../operations/mutations/set-service-store.js';
import '../operations/mutations/set-shipping-method.js';
import '../operations/mutations/set-shipping-state.js';
import '../operations/mutations/create-apple-pay-session.js';
import '../operations/mutations/recreate-ordered-checkout.js';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../operations/fragments/checkout-mutation-result.js';
import '../operations/fragments/cart-mutation-failures.js';
import '../operations/fragments/recreate-ordered-checkout-failure.js';
import '../operations/fragments/recreate-ordered-checkout-result.js';
import '../operations/fragments/paypal-payment.js';
import '../operations/fragments/saved-user-details.js';
import '../operations/queries/get-checkout-state.js';
import '../operations/queries/get-user-details.js';
import '@grandvisionhq/icons';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/locations';
import '../StepShipping/modules/ShippingMethods/containers/PickupPointsFinderContainer.js';
import '../StepShipping/modules/ShippingMethods/containers/StoresFinderContainer.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/shipping';
import '@grandvisionhq/forms';
import '../state.js';
import '@grandvisionhq/lib-utils-html';
import 'classnames';
import '../modules/ExpressCheckout/components/ExpressCheckoutContainer.js';
import 'motion/react';
import 'throttle-debounce';
import '../slots/forms/form-context.js';
import '../slots/summaries/summary-context.js';
import '../slots/summaries/types.js';
import '../modules/ServiceStore/containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import { Header } from '../modules/Header/Header.js';
import '@grandvisionhq/bloomreach';
import './context/context.js';
import { LoggedInExpressCheckoutProvider } from './context/Provider.js';
import { ConsentsAndOptInsContainer } from './modules/ConsentAndOptins/ConsentsAndOptinsContainer.js';
import { ShippingMethodsContainer } from './modules/shipping/ShippingMethodsContainer.js';
import { PaymentsContainer } from './modules/Payments/PaymentsContainer.js';
import { UserDetails } from './modules/UserDetails/UserDetails.js';

const LoginExpressCheckoutContainer = ({ backButton , title , shippingMethodsAsides , selfUrl ,  })=>{
    const { cart , loading , called  } = Context.useCart();
    const { onClick: redirectToCartPage  } = useLink({
        route: 'cart.overview'
    }, {
        replace: true
    }) || {};
    const [, setPaymentStatus] = React.useState('');
    const handleCartError = React.useCallback(()=>{
        if (called && !loading && !cart) {
            console.error('Cart is empty');
            redirectToCartPage === null || redirectToCartPage === void 0 ? void 0 : redirectToCartPage();
        } else if ((cart === null || cart === void 0 ? void 0 : cart.checkoutState) == 'Finalized') {
            console.error('Cart is not in active state');
            toast.failed('cart.errors.cartNotInActiveState');
            redirectToCartPage === null || redirectToCartPage === void 0 ? void 0 : redirectToCartPage();
        }
    }, [
        called,
        cart,
        loading,
        redirectToCartPage
    ]);
    const intl = useIntl();
    const isCheckoutEventFired = React.useRef(false);
    React.useEffect(()=>{
        handleCartError();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        cart
    ]);
    React.useEffect(()=>{
        // should only run once or when the cart or cart line items change
        if (!loading && cart && !isCheckoutEventFired.current) {
            pushCheckoutEventToDataLayer(cart, intl.currency, 'login_checkout');
            isCheckoutEventFired.current = true;
        }
    }, [
        loading,
        cart,
        intl.currency
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "login-express-checkout"
    }, /*#__PURE__*/ React.createElement(Header, {
        title: title,
        backButton: backButton
    }), /*#__PURE__*/ React.createElement("section", {
        className: "login-express-checkout__inner"
    }, /*#__PURE__*/ React.createElement(CartSlider, null, /*#__PURE__*/ React.createElement(Cart, null)), /*#__PURE__*/ React.createElement(LoggedInExpressCheckoutProvider, null, /*#__PURE__*/ React.createElement("section", {
        className: "login-express-checkout__shipping"
    }, /*#__PURE__*/ React.createElement(ShippingMethodsContainer, {
        shippingMethodsAsides: shippingMethodsAsides
    })), /*#__PURE__*/ React.createElement("section", {
        className: "login-express-checkout__user-details"
    }, /*#__PURE__*/ React.createElement(UserDetails, null)), /*#__PURE__*/ React.createElement("section", null, /*#__PURE__*/ React.createElement(ConsentsAndOptInsContainer, null)), /*#__PURE__*/ React.createElement("section", null, /*#__PURE__*/ React.createElement(PaymentsContainer, {
        selfUrl: selfUrl,
        updateCheckoutStatus: setPaymentStatus
    })))));
};
const ExpressLoginCheckoutContainerWithUserData = WithUserData(LoginExpressCheckoutContainer);
const ExpressLoginCheckoutContainerWithMyAccount = (_param)=>{
    var props = swcHelpers.extends({}, _param);
    const { isMyAccountEnabled  } = useFeatureToggles();
    return /*#__PURE__*/ React.createElement(ExpressLoginCheckoutContainerWithUserData, swcHelpers.extends({}, props, {
        isMyAccountEnabled: isMyAccountEnabled
    }));
};

export { ExpressLoginCheckoutContainerWithMyAccount as default };
//# sourceMappingURL=LoginExpressCheckoutContainer.js.map
